import { activity } from '@loom-js/core';

export interface ModalsValue {
    [key: string]: object;
}

export const modals = activity<ModalsValue>({}, ({ input, value, update }) =>
    update({ ...value, ...input })
);
